// 十六进制字符串转十进制数字
const toBit10 = (str) => parseInt(str, 16)
// 十进制数字转十六进制字符串
const toStr16 = (num) => num.toString(16)

// 数字升降阶
const numStep = (fNum, tNum, step) => {
  // 区间差值 * step / 100
  const stepSize = Math.floor((Math.abs(fNum - tNum) * step) / 100)

  return fNum > tNum ? fNum - stepSize : fNum + stepSize
}

/**
 * 使用js处理css颜色渐变
 * @from string #aaaaaa 原颜色
 * @to stirng #aaaaaa 目标颜色
 * @step number 100 步长，当为100时直接返回目标颜色，为0时为原颜色
 */
export function cssColorGradient(from, to, step) {
  const [fr, fg, fb, fa] = cssColorToRGB(from)
  const [tr, tg, tb, ta] = cssColorToRGB(to)

  const newColor = [numStep(fr, tr, step), numStep(fg, tg, step), numStep(fb, tb, step), numStep(fa, ta, step)]

  return rgbToCssColor(newColor)
}

/**
 * 格式化颜色，将#aaa转化为#aaaaaa
 */
export function formatCssColor(color) {
  if (color?.length === 4) return `${color}${color.slice(1)}`
  return color
}

/**
 * 将颜色处理为RGB色值
 */
export function cssColorToRGB(color) {
  const myColor = formatCssColor(color)

  const r = myColor.slice(1, 3)
  const g = myColor.slice(3, 5)
  const b = myColor.slice(5, 7)
  const a = myColor.slice(7) || 'FF'

  return [toBit10(r), toBit10(g), toBit10(b), toBit10(a)]
}

/**
 * 将颜色还原为cssColor
 */
export function rgbToCssColor(rgba) {
  const [r, g, b, a = 'FF'] = rgba

  return `#${toStr16(r)}${toStr16(g)}${toStr16(b)}${toStr16(a)}`
}
